"use client";
import { type FieldValues } from "react-hook-form";
import ErrorMessage from "@/components/common/formElements/controlled/ErrorMessage";
import {
  useCheckboxGroupFieldController,
  type UseCheckboxGroupFieldControllerProps,
} from "@/components/common/formElements/hooks/useCheckboxGroupFieldController";
import CheckboxGroup, {
  type CheckboxGroupProps,
} from "@/components/common/formElements/library/CheckboxGroup";

export interface CheckboxGroupFieldProps<TFieldValues extends FieldValues>
  extends Pick<
      UseCheckboxGroupFieldControllerProps<TFieldValues>,
      "name" | "rules"
    >,
    Omit<
      CheckboxGroupProps,
      "required" | "error" | "onChange" | "errorMessage"
    > {}

export default function CheckboxGroupField<TFieldValues extends FieldValues>(
  props: CheckboxGroupFieldProps<TFieldValues>,
) {
  const { children, name, rules, ...checkboxGroupFieldProps } = props;

  const {
    field,
    required,
    formState: { errors },
    fieldState: { invalid: error },
  } = useCheckboxGroupFieldController<TFieldValues>({ name, rules });

  return (
    <CheckboxGroup
      required={required}
      error={error}
      errorMessage={<ErrorMessage name={field.name} errors={errors} />}
      {...checkboxGroupFieldProps}
    >
      <input type="hidden" {...field} />
      {children}
    </CheckboxGroup>
  );
}
